<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">系统参数</p>
      <div class="content-input">
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeArray" :search-type="searchType" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
<!--          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editParamDialog(-1)">添加系统参数</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1" />
          <el-table-column property="name" label="名称" v-if="checkColList.indexOf('名称') > -1"></el-table-column>
          <el-table-column property="keycode" label="参数代码" v-if="checkColList.indexOf('参数代码') > -1"></el-table-column>
          <el-table-column prop="is_del" label="是否存在" width="" v-if="checkColList.indexOf('是否存在') > -1" >
            <template #default="scope">
              <span>{{scope.row.isDel==0?'存在':scope.row.isDel==1?'删除':''}}</span>
            </template>
          </el-table-column>
          <el-table-column property="description" label="参数说明" v-if="checkColList.indexOf('参数说明') > -1"></el-table-column>
          <el-table-column property="config" label="配置" v-if="checkColList.indexOf('配置') > -1"></el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-button @click="editParamDialog(scope.$index,scope.row)" type="text">编辑</el-button>
              <el-button type="text" class="copy-param" :data-clipboard-text="scope.row.name + '&' + scope.row.keycode + '&' + scope.row.description + '&' + scope.row.config" @click="copy">复制</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import SearchComponents from '../../components/SearchComponents'
// import BtnGroup from '../../components/BtnGroup'
import { getSysParamPageList } from '../../api/url'
import { getFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import SysParamDialog from "@/views/setting/components/SysParamDialog";
import Clipboard from "clipboard";

export default {
  name: "SysParam",
  components: { SearchComponents },
  data() {
    return {

      //搜索
      searchValue: '',
      searchTypeArray: [
        {label:'名称', value:1},
        {label:'参数代码', value:2},
        {label:'参数说明', value:3},
        {label:'配置', value:4},
      ],
      searchType: 1,

      //刷新组
      colList: ['创建时间', '名称', '参数代码', '是否存在', '参数说明', '配置', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.searchType = 1;
      this.searchValue = ''
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['searchType'] = this.searchValue?this.searchType:-1;
      param['searchValue'] = this.searchValue?this.searchValue:null;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getSysParamPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.pageDataList.forEach((item)=> {
            let timestamp = item.createTime
            let newDate = new Date(parseInt(timestamp))
            let y = newDate.getFullYear();
            let m = newDate.getMonth()+1;
            let d = newDate.getDate();
            item.createTime = y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
          })
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editParamDialog(idx, row) {
      let _title = '';
      let paramForm = {}
      if (idx > -1) {
        _title = '编辑系统参数'
        paramForm = Object.assign({}, row);
      }else {
        _title = '添加系统参数'
      }
      Dialog.open({
        title: _title,
        component: SysParamDialog,
        data: {
          paramForm: paramForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
          if(idx > -1) {
            this.pageDataList[idx]['name'] = result['name']
            this.pageDataList[idx]['description'] = result['description']
            this.pageDataList[idx]['keycode'] = result['keycode']
            this.pageDataList[idx]['config'] = result['config']
          }else{
            this.getPage()
          }
        }
      })
    },


    copy() {
      let clipboard = new Clipboard('.copy-param')
      clipboard.on('success',e =>{
        this.$message({
          showClose: true,
          duration: 1000,
          message: '复制成功',
          type: 'success'
        })
        clipboard.destroy() //使用destroy可以清楚缓存
      })
      clipboard.on('error',e =>{
        this.$message({
          showClose: true,
          duration: 1000,
          message: '复制失败',
          type: 'success'
        })
        clipboard.destroy()
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
